import React from 'react'
// import Receptionarea from "../images/reception area.jpg";
// import Receptionabooking from "../images/reception-krishnanagar.jpg";
// import receptionmaingate from "../images/reception_main_gate.jpg";
// import receptionmaingatemain from "../images/reception-gate.jpg";
// import krishnagarhotel from "../images/reception_gate_krishnanagar.jpg";
import room from "../images/Room.png"




function SuperDeluxeroom() {
  return (
    <div>
      <center>
      <div className='fonts'>
         <div className='album py-1'>
        <div className='container'>
        <h2 style={{color:"#056022"}}>Sampang's Homestay, Kalimpong</h2>
        </div>
        </div>
        </div>
      </center>

      <div className='album py-3'>
        <div className='container'>

          <div className="card mb-3" >
            <div className="row g-0">
              <div className="col-md-5">
             
                <img src={room} className="img-fluid rounded-start" alt="Receptionpaulshotel" />
              </div>
              <div className="col-md-7">
                <div className="card-body">
                  <h4 className="card-title"><b style={{color:"#040e7a"}}>Super Deluxe Room <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                  </svg></b></h4>
                  <p className="card-text">No1 Room (Sampang's Homestay) in Kalimpong </p>
                <p style={{color:"#01450a"}}>All rooms feature a private balcony with beautiful views, along with geyser facilities and hot water available 24/7 for your comfort and convenience.</p>

                  <h5 className='mb-3'>Check in 11AM, Check Out 10:00AM</h5>
                  <h4>Tariff: 2000/-</h4>
                  <a href='tel: +91 9332131717'>
                    <button className="button10 button11 me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                    </svg> Book Now</button>
                  </a>
                 






                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  

    </div>
  )
}

export default SuperDeluxeroom